module.exports = __webpack_public_path__ + "img/stairs.ee2d4e98.svg";